import { Children, cloneElement, isValidElement, type ReactNode } from 'react';
interface FieldChild {
  id?: string;
  children?: ReactNode;
  'aria-describedby'?: string;
  'aria-invalid'?: boolean | 'true' | 'false';
}
export function associateField(
  children: ReactNode,
  id: string,
  description: string,
  invalid: boolean,
): ReactNode {
  return Children.map(children, (child) => {
    if (!isValidElement<FieldChild>(child)) return child;
    const element = child;
    const name =
      typeof element.type === 'string'
        ? element.type
        : (element.type as { displayName?: string }).displayName;
    if (['input', 'select', 'textarea', 'Input', 'Select', 'Textarea'].includes(name ?? '')) {
      const descriptions = [
        ...new Set(
          [element.props['aria-describedby'], description].filter(Boolean).join(' ').split(' '),
        ),
      ]
        .filter(Boolean)
        .join(' ');
      return cloneElement(element, {
        id,
        'aria-describedby': descriptions || undefined,
        'aria-invalid': invalid || element.props['aria-invalid'],
      });
    }
    return element.props.children
      ? cloneElement(element, {}, associateField(element.props.children, id, description, invalid))
      : child;
  });
}
